import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate } from '@angular/router';
import { GlobalService } from '../api/global.service';
import * as _ from 'underscore';
import AlertifyHelper from '../utils/utils';

@Injectable()
export class BranchofficeGuard implements CanActivate {
  constructor(
    private router: Router,
    private globalService: GlobalService,
    private alertifyMsg: AlertifyHelper
  ) {}

  canActivate() {
    if (_.isUndefined(this.globalService.getSlugBranchoffice())) {
      this.goBackBranchoffices();
      return false;
    }

    if (_.isNull(this.globalService.getSlugBranchoffice())) {
      this.goBackBranchoffices();
      return false;
    }

    if (_.isUndefined(this.globalService.getPassActivation())) {
      this.goBackBranchoffices();
      return false;
    }

    if (_.isNull(this.globalService.getPassActivation())) {
      this.goBackBranchoffices();
      return false;
    }else{
      if(this.globalService.getPassActivation() != "activate"){
        this.goBackBranchoffices();
        return false;
      }
    }

    return true;
  }

  goBackBranchoffices() {
    this.alertifyMsg.warning('Debe seleccionar la sucursal para poder continuar');
    this.router.navigate(['/admin/sucursales']);
  }
}
